// ─── Static Events Data ───
export const STATIC_EVENTS = [
  {
    id: 1,
    type: '🎬 Live Screening',
    typeClass: 'type-screening',
    bannerClass: '',
    title: 'El Clásico Watch Party',
    dateStr: 'Saturday, 26 October 2025 · 9:00 PM IST',
    venue: 'The Pint Room, Indiranagar, Bengaluru',
    capacity: 'Capacity: 200 seats · 68 remaining',
    price: '₹499',
    priceLabel: 'per person',
    cta: 'Book Seat',
    desc: 'The biggest match in world football. Join 200 Culers at The Pint Room for a full match-day experience — reserved seating, Barça merch giveaways, and DJ set post-game.',
  },
  {
    id: 2,
    type: '⭐ Special Event',
    typeClass: 'type-special',
    bannerClass: 'gold',
    title: 'Champions League Night',
    dateStr: 'Wednesday, 6 November 2025 · 1:30 AM IST',
    venue: 'Toit Brewpub, Sadashivanagar, Bengaluru',
    capacity: 'Capacity: 150 · Members get priority',
    price: '₹799',
    priceLabel: 'per person',
    cta: 'Book Seat',
    desc: 'UCL knockout stage. Full venue takeover with giant screens, food & drinks packages, and a special halftime trivia with prizes worth ₹10,000.',
  },
  {
    id: 3,
    type: '🤝 Member Meetup',
    typeClass: 'type-meetup',
    bannerClass: 'red',
    title: 'Culers Bengaluru Meetup',
    dateStr: 'Sunday, 10 November 2025 · 4:00 PM IST',
    venue: 'Cubbon Park Amphitheatre, Bengaluru',
    capacity: 'Open to all · Members Free',
    price: 'FREE',
    priceLabel: 'for members',
    cta: 'RSVP Now',
    desc: 'Our quarterly community meetup. New season introductions, merchandise preview, plans for upcoming match screenings, and plenty of Barça banter over food.',
  },
  {
    id: 4,
    type: '🎬 Live Screening',
    typeClass: 'type-screening',
    bannerClass: '',
    title: 'Derby Day: La Liga Weekend',
    dateStr: 'Saturday, 23 November 2025 · 10:15 PM IST',
    venue: 'Hard Rock Café, MG Road, Bengaluru',
    capacity: 'Capacity: 120 seats',
    price: '₹599',
    priceLabel: 'per person',
    cta: 'Book Seat',
    desc: "Barça take on Atletico Madrid. Join the Culers at Hard Rock for live screening, FC Barcelona jersey night, and dinner combos with drinks.",
  },
  {
    id: 5,
    type: '⭐ Annual Event',
    typeClass: 'type-special',
    bannerClass: 'gold',
    title: 'FCB Bengaluru Annual Gala',
    dateStr: 'Saturday, 14 December 2025 · 7:00 PM IST',
    venue: 'The Lalit Ashok Hotel, Bengaluru',
    capacity: '300 seats · Black tie optional',
    price: '₹2,999',
    priceLabel: 'per couple',
    cta: 'Get Tickets',
    desc: 'Our flagship annual celebration. Awards night, season highlights reel, exclusive merchandise auction, live performances, gourmet dinner, and the FCB Bengaluru Member of the Year award.',
  },
  {
    id: 6,
    type: '🤝 5-a-side',
    typeClass: 'type-meetup',
    bannerClass: 'red',
    title: 'Culers Football Tournament',
    dateStr: 'Sunday, 5 January 2026 · 7:00 AM IST',
    venue: 'Delhi Public School Grounds, Whitefield',
    capacity: '16 teams max · Register as team of 5',
    price: '₹1,500',
    priceLabel: 'per team',
    cta: 'Register Team',
    desc: 'Play like your heroes. Register your 5-a-side team for the FCB Bengaluru inter-fan tournament. Winners receive exclusive FCB Bengaluru trophies and merchandise bundles.',
  },
];

// ─── Static Merch Data ───
export const STATIC_MERCH = [
  {
    id: 101,
    name: 'FCB Bengaluru Scarf',
    category: 'Accessories · Official Fan Merchandise',
    price: '799',
    badge: 'Bestseller',
    stock: 'In stock',
    desc: `Crafted in official Barça Blaugrana — the deep blue and rich garnet red that defines everything we stand for.\n\nDouble-layer knit, 160cm × 20cm. Woven "FCB Bengaluru" branding on one end, classic Barça stripes on the reverse.\n\nWorn at every screening. Raised at every goal. Tied to every memory.`,
    tagline: 'One scarf. A thousand moments.',
    photos: ['/images/merch/scarf_1.jpg', '/images/merch/scarf_2.jpg'],
  },
];

// ─── Membership Tiers ───
export const MEMBERSHIP_TIERS = [
  {
    id: 'culer',
    icon: '⚽',
    name: 'Culer',
    tagline: 'Start your Blaugrana journey',
    price: '399',
    period: 'per year',
    featured: false,
    features: [
      { check: true, text: 'Priority access to all screenings' },
      { check: true, text: '10% off screening tickets' },
      { check: true, text: '10% off F&B at partner venues' },
      { check: true, text: '10% off all merchandise' },
      { check: true, text: 'Member-only announcements' },
      { check: true, text: 'Physical membership card' },
    ],
    btnClass: 'btn-tier-outline',
    btnText: 'Join as Culer',
  },
  {
    id: 'soci',
    icon: '🔵🔴',
    name: 'Soci',
    tagline: 'The true Barça experience',
    price: '999',
    period: 'per year',
    featured: true,
    popular: true,
    features: [
      { subheading: true, text: 'Everything in Culer, plus:' },
      { check: true, text: '<strong>25% off</strong> screening tickets' },
      { check: true, text: '<strong>15% off</strong> F&B at partner venues' },
      { check: true, text: '<strong>15% off</strong> all merchandise' },
      { check: true, text: 'Table reservation <em>(subject to availability)</em>' },
      { check: true, text: 'Exclusive FCB Bengaluru goodie kit' },
      { check: true, text: 'Priority access to limited-seat events' },
    ],
    btnClass: 'btn-tier-gold',
    btnText: 'Join as Soci',
  },
];

// ─── Contact Info ───
export const CONTACT_INFO = [
  { icon: '📧', color: 'gold', label: 'Email Us', value: 'barcabengaluru@gmail.com', href: 'mailto:barcabengaluru@gmail.com' },
  { icon: '💬', color: 'green', label: 'WhatsApp', value: '+91 97779 12631', href: 'https://wa.me/919777912631' },
  { icon: '📍', color: 'blue', label: 'Registered Address', value: 'Indiranagar, Bengaluru — 560038, Karnataka', href: null },
];

export const SOCIAL_LINKS = [
  { icon: '📸', label: 'Instagram', href: 'https://www.instagram.com/fcbbengaluru/' },
  { icon: '𝕏', label: 'Twitter/X', href: 'https://x.com/fcb_bengaluru' },
  { icon: '🧵', label: 'Threads', href: 'https://www.threads.com/@fcbbengaluru' },
  { icon: '▶', label: 'YouTube', href: 'https://www.youtube.com/@FCBBengaluru' },
];
